import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { IContentSearchResult } from '../../domain/types/IContentSearchResult';
import { List } from './list/List';
import { ChevronDownIcon, ContentWrap, Flex, Responsive } from '../../../../ui';
import { ISearchPagination } from '../../domain/types/ISearchPagination';
import Button from '../../../../components/common/button/Button';

interface IProps {
	results: IContentSearchResult[];
	pagination: ISearchPagination;
	onLoadMore: () => void;
}

export const SearchResults = observer(
	({ results, pagination, onLoadMore }: IProps) => (
		<ListWrapper>
			<List results={results} />
			{results.length < pagination.nbHits && (
				<Flex justifyContent="center" alignItems="center">
					<Button
						buttonType="outlined"
						icon={<ChevronDownIcon role="presentation" />}
						onClick={onLoadMore}
					>
						Load more
					</Button>
				</Flex>
			)}
		</ListWrapper>
	),
);

const ListWrapper = styled.div`
	flex: 1;
	padding: 0;
	width: 100%;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		${ContentWrap} {
			margin: 0;
		}
	}
`;
